const SvgSecure1 = (props) => (
  <>
    <defs />
    <path
      d="M384 0c0 106.04-85.96 192-192 192S0 106.04 0 0h384ZM384 192c0 106.04-85.96 192-192 192S0 298.04 0 192h384Z"
      fill={props.p10}
    />
  </>
);

export default SvgSecure1;
